import { useContext } from 'react';
import SettingsService, { SettingsContext } from 'Services/SettingsService';

const useSetting = (key) => {
  const settings = useContext(SettingsContext);
  return SettingsService.getValueForKey(key, settings);
};

export default useSetting;
